var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.717,
    height: 9.717,
    viewBox: "0 0 9.717 9.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-help-circle-outline",
    "data-name": "Icon ionic-ios-help-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M8.233,4.029A4.2,4.2,0,1,1,5.26,5.26,4.177,4.177,0,0,1,8.233,4.029m0-.654a4.858,4.858,0,1,0,4.858,4.858A4.858,4.858,0,0,0,8.233,3.375Z",
    fill: "#277191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M15.011,11.25c.876,0,1.479.486,1.479,1.184a1.142,1.142,0,0,1-.656,1.037c-.406.236-.544.409-.544.708v.185h-.811l-.007-.2a.972.972,0,0,1,.551-1.028c.395-.236.561-.385.561-.675a.567.567,0,0,0-.628-.5.591.591,0,0,0-.626.575H13.5A1.333,1.333,0,0,1,15.011,11.25Zm-.614,4a.5.5,0,1,1,.5.481A.489.489,0,0,1,14.4,15.254Z",
    transform: "translate(-6.761 -5.259)",
    fill: "#277191"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircleOutline);
export default __webpack_public_path__ + "static/media/help-circle-outline.1297ded0fd612b4e7452018d23a95a7e.svg";
export { ForwardRef as ReactComponent };